import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';
import data from '../../Emails.json';

import './Upload.css';
import { axiosFileInstance } from '../../axios';
function Upload({ showWarning, showSuccess, showError }) {
  //Selected Email's
  const [emailList, setEmailList] = useState(data);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputActive, setInputActive] = useState(false);
  const [emailOptions, setEmailOptions] = useState([]);
  const [emailSearching, setEmailSearching] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [speakers, setSpeakers] = useState([1, 1]);

  const [inputTitle, setInputTitle] = useState('');
  const [inputProduct, setInputProduct] = useState('');

  const inputRef = useRef(null);
  // uploaded and settings data
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedPpt, setuploadedPpt] = useState(null);
  const navigate = useNavigate();


  // Upload audio request
  const onSubmitForm = async () => {
    // setLoading(true)
    if (inputTitle == '') {
      showWarning('회의록 제목 입력하세요!')

    }
    else if (inputProduct == '') {
      showWarning('회의록 제품명 입력하세요!')

    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append('title', inputTitle);
        formData.append('audioFile', uploadedFile);
        formData.append('pptFile', uploadedPpt);
        formData.append('productName', inputProduct);
        formData.append('min_speaker', speakers[0])
        formData.append('max_speaker', speakers[1])
        // Extract email strings and convert to JSON string
        const emailStrings = selectedEmails.map(emailObj => emailObj.EMAIL);
        console.log(emailStrings);
        formData.append('emails', JSON.stringify(emailStrings));
        formData.append('type', '회의록');
        formData.append('progress', '대기');
        const response = await axiosFileInstance.post('solo_audio', formData)


        if (response?.status == 201) {
          // console.log(response?.data)
          showSuccess('회의록 성공적으로 추가되었습니다!')
          navigate('/')
        }
        else if (response?.status == 404) {
          console.log("error")
          showError('회의록 업로드 실패했습니다!')
        }
        // else if (response?.data == "Incorrect password!") {
        //     console.log("Incorrect password!");
        // }
      } catch (error) {
        showError('음서 업로드가 실패했습니다! 네트워크 상태를 확인해주세요.')
        setLoading(false);
        // setLoading(false)
        // TODO: handle errors
      }
    }
  }

  // handle input title
  const handleInputTitle = (event) => {
    setInputTitle(event.target.value);
  };

  // handle input product
  const handleInputProduct = (event) => {
    setInputProduct(event.target.value);
  };



  const handleInputFocus = () => {
    setInputActive(true);
  };

  const handleInputBlur = () => {
    setInputActive(false);
  };



  const handleEmailInputChange = (e) => {
    console.warn(data.length);
    const value = e.target.value.toLowerCase();
    setInputValue(value);
    setEmailSearching(true);
    if (value.length >= 1) {
      debounceSearch(value);
    } else {
      setEmailOptions([]);
    }
  };

  // Debounce the email search function
  const debounceSearch = useRef(
    debounce((value) => {
      // Filter options with added checks for undefined properties
      const filteredOptions = emailList.filter((item) =>
        (item.USER_NAME && item.USER_NAME.toLowerCase().includes(value)) ||
        (item.EMAIL && item.EMAIL.toLowerCase().includes(value))
      );
      setEmailOptions(filteredOptions);
      setEmailSearching(false);
    }, 500)
  ).current;


  // On select email
  const handleEmailSelect = (email) => {
    if (email.EMAIL) {
      // Regular expression for basic email validation
      const emailRegex = /\S+@\S+\.\S+/;
      if (emailRegex.test(email.EMAIL)) {
        if (selectedEmails.some(selectedEmail => selectedEmail.EMAIL === email.EMAIL)) {
          showWarning("이미 등록된 이메일입니다!"); // Display a warning if the email already exists
        } else {
          setSelectedEmails([...selectedEmails, email]);
        }
        setInputValue(''); // Set the input field value to the selected option
        setEmailOptions([]); // Clear the suggestion list
      } else {
        showWarning("유효한 이메일 주소를 입력하세요!")
      }
    } else {
      showWarning("이메일 주소를 입력하세요!"); // Show a warning when the email field is empty
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    handleEmailSelect({ "EMAIL": inputValue });
  };



  // handle for remove clicked email
  const handleEmailRemove = (email) => {
    setSelectedEmails(selectedEmails.filter(item => item.EMAIL !== email.EMAIL));

  }

  const handleIncreaseCustomers = () => {
    // Increase the number of customers
    const updatedSpeakers = [...speakers];
    updatedSpeakers[0]++;
    setSpeakers(updatedSpeakers);
  };

  const handleDecreaseCustomers = () => {
    // Decrease the number of customers (with a minimum value of 1)
    const updatedSpeakers = [...speakers];
    if (updatedSpeakers[0] > 1) {
      updatedSpeakers[0]--;
      setSpeakers(updatedSpeakers);
    }
  };

  const handleIncreaseTotalParticipants = () => {
    // Increase the total number of participants
    const updatedSpeakers = [...speakers];
    updatedSpeakers[1]++;
    setSpeakers(updatedSpeakers);
  };

  const handleDecreaseTotalParticipants = () => {
    // Decrease the total number of participants (with a minimum value of 1)
    const updatedSpeakers = [...speakers];
    if (updatedSpeakers[1] > 1) {
      updatedSpeakers[1]--;
      setSpeakers(updatedSpeakers);
    }
  };


  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };



  // stage
  const [currentStage, setCurrentStage] = useState(1);

  const handleUploadPpttoServer = () => {
    if (uploadedFile) {
      console.log('file uploaded');
      setCurrentStage(3);
    }
  };

  const handleUploadFiletoServer = () => {
    if (uploadedFile) {
      console.log('file uploaded');
      setCurrentStage(2);
    }
  };

  const handlePptCancleClick = () => {
    if (uploadedPpt) {
      const confirmation = window.confirm('업로드된 파일을 취소하시겠습니까?');

      if (confirmation) {
        // User confirmed to cancel the uploaded file
        setuploadedPpt(null);
      }
    }
  }


  const handleFileSelectPpt = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.ppt, .pptx'; // Specify the allowed file formats
    fileInput.click();
    fileInput.addEventListener('change', (event) => {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        // Check if the file extension is .ppt or .pptx
        if (/\.(ppt|pptx)$/i.test(selectedFile.name)) {
          setuploadedPpt(selectedFile);
          console.log('Selected file:', selectedFile);
        } else {
          // Show warning if the file extension is not .ppt or .pptx
          showWarning('지원되지 않는 파일 형식입니다.');
        }
      }
    });
  };

  const handleFileSelect = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.wav, .m4a'; // Specify the allowed file formats
    fileInput.click();
    fileInput.addEventListener('change', (event) => {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        // Check if the file extension is .wav or .m4a
        if (/\.(wav|m4a)$/i.test(selectedFile.name)) {
          setUploadedFile(selectedFile);
          console.log('Selected file:', selectedFile);
        } else {
          // Show warning if the file extension is not .wav or .m4a
          showWarning('지원되지 않는 파일 형식입니다.');
        }
      }
    });
  };

  const handleCancelClick = () => {
    if (uploadedFile) {
      const confirmation = window.confirm('업로드된 파일을 취소하시겠습니까?');

      if (confirmation) {
        // User confirmed to cancel the uploaded file
        setUploadedFile(null);
      }
    } else {
      navigate('/');
    }
  };

  const handleFinishUpload = () => {
    // User confirmed to cancel the uploaded file
    onSubmitForm();
  };

  // Define separate components for each stage
  const Stage1 = (
    <>
      <h3 className="text-center">음성 업로드</h3>

      <div className="container">
        <a onClick={handleFileSelect}>
          <div className="dotted-border rounded text-center hover-effect">
            <div className="row align-items-center">
              {uploadedFile ? (
                <>
                  <div className="col-12">
                    <p className="text-center">
                      <i
                        className="fas fa-lg fa-fw mb-2 fa-file-audio"
                        style={{ paddingRight: 10 }}
                      ></i>
                    </p>
                  </div>
                  <div className="col-12"><h4>
                    {uploadedFile.name}
                  </h4>
                  </div>
                </>
              ) : (
                <>
                  <div className="col-12">
                    <i className="fas fa-lg fa-fw mb-2 fa-upload"></i>
                  </div>
                  <div className="col-12">
                    <p>음성파일 업로드 (wav, m4a)</p>
                  </div>
                </>
              )}
            </div>
          </div>
        </a>
        <div className="text-center">
          <button
            className="btn btn-secondary"
            style={{ marginRight: 5 }}
            onClick={handleCancelClick}
          >
            취소
          </button>

          <button
            className="btn btn-primary"
            disabled={!uploadedFile}
            style={{ marginLeft: 5 }}
            onClick={() => handleUploadFiletoServer()}
          >
            업로드하기
          </button>
        </div>
      </div>
    </>
  );

  // Settings audio file
  const Stage2 = (
    <>
      <h3 className="text-center">음성파일 설정</h3>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-sm-12 col-md-10" style={{ marginTop: '1.75rem' }}>
            <div class="form-group mb-3 ">


              <div className="col-sm-12 col-md-10 mx-auto justify-content-center">

                <div className='row  mx-auto justify-content-center' >

                  <div className='col-lg-4 col-sm-6' >
                    <label for="staticEmail" class="col-form-label col-12">고객 수: <span class="text-danger">*</span></label>
                    <div class="input-group flex-nowrap ">

                      <btn class="input-group-text" style={{ cursor: 'pointer' }} onClick={handleDecreaseCustomers}> - </btn>
                      <input
                        type="text"
                        value={speakers[0]}
                        onChange={handleInputChange}
                        placeholder={speakers[0]}
                        class="form-control text-center"
                      />

                      <btn class="input-group-text" style={{ cursor: 'pointer' }} id="addon-wrapping" onClick={handleIncreaseCustomers}>+</btn>
                    </div>

                  </div>
                  <div className='col-lg-4 col-sm-6'>
                    <label for="staticEmail" class="col-form-label col-12">전체 참여자 수: <span class="text-danger">*</span></label>
                    <div class="input-group flex-nowrap">
                      <btn class="input-group-text" style={{ cursor: 'pointer' }} onClick={handleDecreaseTotalParticipants}>-</btn>
                      <input
                        type="text"
                        value={speakers[1]}
                        onChange={handleInputChange}
                        placeholder={speakers[1]}
                        class="form-control text-center"
                      />
                      <btn class="input-group-text" style={{ cursor: 'pointer' }} id="addon-wrapping" onClick={handleIncreaseTotalParticipants}>+</btn>
                    </div>
                  </div>
                </div>
                <div className='row  mx-auto justify-content-center'>
                  <div className="col-lg-8 col-sm-12 mx-auto justify-content-center" style={{ marginTop: '1.75rem', position: 'relative' }}>
                    {/* <label for="staticEmail" class="col-form-label col-12 text-center">공유 메일 주소:</label> */}
                    <label class="form-label">공유 이메일 주소 <span class="text-danger">*</span></label>
                    <div class="input-group flex-nowrap">

                      <input
                        autocomplete="off"
                        value={inputValue}
                        onChange={handleEmailInputChange}
                        placeholder='email'
                        class="form-control"
                        id="typeahead"
                        list="emailList"
                      // onFocus={handleInputFocus}
                      // onBlur={handleInputBlur}
                      />

                      {/* Email select options */}
                      {/* {
                        !emailSearching && emailOptions.length === 0 && inputValue.length >= 1 && (
                          <>
                            <div id="1" aria-label="menu-options" class="col-lg-12 col-md-12 col-sm-12 rbt-menu dropdown-menu show dropdown-suggesion-style" style={{ paddingLeft: 20, paddingRight: 20, position: 'absolute' }} role="listbox" data-popper-reference-hidden="false" data-popper-escaped="false"
                              data-popper-placement="bottom-start">

                              <li class="d-flex align-items-center list-item-style">
                                <div class="flex-1 px-3">
                                  <div class="text-muted small">ㄹ</div>
                                </div>
                              </li>
                            </div>
                          </>
                        )
                      } */}

                      {
                        !emailSearching && emailOptions.length > 0 && (
                          <>
                            <div id="1" aria-label="menu-options" class="col-lg-12 col-md-12 col-sm-12 rbt-menu dropdown-menu show dropdown-suggesion-style" style={{ paddingLeft: 20, paddingRight: 20, position: 'absolute' }} role="listbox" data-popper-reference-hidden="false" data-popper-escaped="false"
                              data-popper-placement="bottom-start">
                              {emailOptions.map((email, index) => (
                                <>
                                  <hr class="opacity-1"></hr>
                                  <li class="d-flex align-items-center list-item-style " onClick={() => handleEmailSelect(email)}>
                                    {/* <div>
                                                                <div class="w-60px h-60px fs-20px rounded-pill d-flex align-items-center justify-content-center bg-body text-body">
                                                                    <img alt="" class="mw-100 mh-100  rounded-pill" src={`http://www.bearworld.co.kr${email.AVATAR}`} />
                                                                </div>
                                                            </div> */}
                                    <div class="flex-1 px-3">
                                      <h5 class="mb-0 fw-semibold "><b>{email.USER_NAME}</b></h5>
                                      <div class="text-muted small">{email.EMAIL} </div>
                                      <div class="text-muted small">{email.COMPANY_NAME} </div>
                                    </div>
                                  </li>
                                  <hr class="opacity-1"></hr>
                                </>
                              ))}
                            </div>
                          </>
                        )}


                      {/* <button class="btn btn-warning text-white" style={{ width: 100 }} onClick={() => handleEmailSelect({ "email": inputValue })}>추가</button> */}
                    </div>
                  </div>
                </div>
                {/* <div className='row  mx-auto justify-content-center'>
                  <div className="col-lg-8 col-sm-12 mx-auto justify-content-center" style={{ marginTop: '1.75rem', position: 'relative' }}>
                    <label class="form-label">공유 이메일 주소 <span class="text-danger">*</span></label>
                    <form onSubmit={handleFormSubmit}>
                      <div className="input-group flex-nowrap">
                        <input
                          autoComplete="off"
                          value={inputValue}
                          onChange={handleEmailInputChange}
                          placeholder='email'
                          className="form-control"
                          id="typeahead"
                          list="emailList"
                        />
                        <button type="submit" className="btn btn-warning text-white" style={{ width: 100 }}>추가</button>
                      </div>
                    </form>
                  </div>
                </div> */}
              </div>
            </div>




            {/* Email Section */}

            <div className='col-lg-12 mx-auto' style={{ marginTop: '1.75rem' }}>

              <div className="">
                <div className="row ">
                  {selectedEmails.map((email, index) => (
                    <>
                      <div class="col-xl-4 col-lg-6">

                        <div class="card mb-3">
                          <div class="card-body">
                            <div className="d-flex align-items-center ">
                              <div>
                                {/* <div className="w-60px h-60px fs-20px rounded-pill d-flex align-items-center justify-content-center bg-body text-body">
                                                                    <img alt="" className="mw-100 mh-100 rounded-pill" src={email.img} />
                                                                </div> */}
                              </div>
                              <div className="flex-1 px-3">
                                <h5 className="mb-0 fw-semibold"><b>{email.USER_NAME}</b></h5>
                                <div className="text-muted">{email.EMAIL}</div>
                              </div>
                              <div className="fs-20px">
                                <a href="#" onClick={() => handleEmailRemove(email)} className="text-body text-opacity-30"><i className="fa fa-times"></i></a>
                              </div>
                            </div>
                          </div>
                        </div></div>
                    </>
                  ))}

                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="text-center">
          <button
            className="btn btn-secondary"
            style={{ marginRight: 5 }}
            onClick={() => setCurrentStage(1)}
          >
            뒤로가기
          </button>
          <button
            className="btn btn-primary"
            disabled={!uploadedFile}
            style={{ marginLeft: 5 }}
            onClick={() => setCurrentStage(3)}
          >
            저장하기
          </button>
        </div>
      </div >
    </>
  );

  // Upload Document
  const Stage3 = (
    <>
      <h3 className="text-center">문서파일 업로드</h3>
      <div className="container">
        <a onClick={handleFileSelectPpt}>
          <div className="dotted-border rounded text-center hover-effect">
            <div className="row align-items-center">
              {uploadedPpt ? (
                <>
                  <div className="col-12">
                    <p className="text-center">
                      <i
                        className="fas fa-lg fa-fw mb-2 fa-file-powerpoint"
                        style={{ paddingRight: 10 }}
                      ></i>
                    </p>
                  </div>
                  <div className="col-12"><p>
                    {uploadedPpt.name}
                  </p>
                  </div>
                </>
              ) : (
                <>
                  <div className="col-12">
                    <i className="fas fa-lg fa-fw mb-2 fa-upload"></i>
                  </div>
                  <div className="col-12">
                    <p >소개/자문 PPT 업로드(ppt, pptx)</p>
                  </div>
                </>
              )}
            </div>
          </div>
        </a>
        <div className="text-center">
          {
            uploadedPpt ? (<>
              <button
                className="btn btn-secondary"
                style={{ marginRight: 5 }}
                onClick={() => handlePptCancleClick()}
              >
                취소
              </button>
            </>) : (<>
              <button
                className="btn btn-secondary"
                style={{ marginRight: 5 }}
                onClick={() => setCurrentStage(1)}
              >
                뒤로가기
              </button>
            </>)
          }


          <button
            className="btn btn-primary"
            disabled={!uploadedPpt}
            style={{ marginLeft: 5 }}
            onClick={() => handleUploadPpttoServer()}
          >
            업로드하기
          </button>
        </div>
      </div >
    </>
  );

  // Setup summary
  const Stage4 = (
    <>
      <h3 className="text-center">음성 및 회의록 초안 설정</h3>
      <div className="container col-md-8 col-sm-12 col-lg-6">
        <div class="card mb-3">
          <div class="hljs-container border-0 rounded">
            <div className='row  mx-auto justify-content-center' style={{marginBottom:24}} >

              <div className='col-lg-4 col-sm-6' >
                <label for="staticEmail" class="col-form-label col-12">고객 수: <span class="text-danger">*</span></label>
                <div class="input-group flex-nowrap ">

                  <btn class="input-group-text" style={{ cursor: 'pointer' }} onClick={handleDecreaseCustomers}> - </btn>
                  <input
                    type="text"
                    value={speakers[0]}
                    onChange={handleInputChange}
                    placeholder={speakers[0]}
                    class="form-control text-center"
                  />

                  <btn class="input-group-text" style={{ cursor: 'pointer' }} id="addon-wrapping" onClick={handleIncreaseCustomers}>+</btn>
                </div>

              </div>
              <div className='col-lg-4 col-sm-6'>
                <label for="staticEmail" class="col-form-label col-12">전체 참여자 수: <span class="text-danger">*</span></label>
                <div class="input-group flex-nowrap">
                  <btn class="input-group-text" style={{ cursor: 'pointer' }} onClick={handleDecreaseTotalParticipants}>-</btn>
                  <input
                    type="text"
                    value={speakers[1]}
                    onChange={handleInputChange}
                    placeholder={speakers[1]}
                    class="form-control text-center"
                  />
                  <btn class="input-group-text" style={{ cursor: 'pointer' }} id="addon-wrapping" onClick={handleIncreaseTotalParticipants}>+</btn>
                </div>
              </div>
            </div>
            <div className="row">
              <div class="mb-3">
                <label class="form-label">제품명 <span class="text-danger">*</span></label>
                <input type="text" value={inputProduct} onChange={handleInputProduct} on class="form-control form-control-lg" placeholder="" />
              </div>
              <div class="mb-3">
                <label class="form-label">회의록 제목 <span class="text-danger">*</span></label>
                <input type="text" value={inputTitle} onChange={handleInputTitle} class="form-control form-control-lg" placeholder="" />
              </div>
            </div></div></div>
        <div className="text-center">
          <button
            className="btn btn-secondary"
            style={{ marginRight: 5 }}
            disabled={loading}
            onClick={() => setCurrentStage(2)}
          >
            뒤로가기
          </button>

          <button
            className="btn btn-primary"
            disabled={!uploadedFile || loading}
            style={{ marginLeft: 5, width: '120px' }}
            onClick={() => onSubmitForm()}

          >
            {loading ? (
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : (
              '저장하기'
            )}
          </button>
        </div>
      </div>
    </>
  );

  // navbar wizard status
  const navLinks = [
    { text: '음성파일 업로드', stage: 1 },
    // { text: '음성파일 설정', stage: 2 },
    { text: '문서파일 업로드', stage: 2 },
    { text: '회의록 초안 설정', stage: 3 }
  ];

  let currentStageComponent;
  if (currentStage === 1) {
    currentStageComponent = Stage1;
  }
  // else if (currentStage === 2) {
  //   currentStageComponent = Stage2;
  // } 
  else if (currentStage === 2) {
    currentStageComponent = Stage3;
  } else if (currentStage === 3) {
    currentStageComponent = Stage4;
  }

  return (
    <>
      <div class="card mb-3">
        <div class="hljs-container border-0 rounded">
          <div className="row">
            <div class="nav-wizards-container">
              <nav class="nav nav-wizards-1 mb-2">
                {navLinks.map((navLink, index) => (
                  <div class="nav-item col" key={index}>
                    <a
                      class={`nav-link ${currentStage === navLink.stage
                        ? 'active'
                        : currentStage > navLink.stage
                          ? 'completed'
                          : 'disabled'
                        }`}
                      href="#"
                    >
                      <div class="nav-no">{index + 1}</div>
                      <div class="nav-text">{navLink.text}</div>
                    </a>
                  </div>
                ))}
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="hljs-container border-0 rounded">
          {currentStageComponent}

          {/* <div className='btn-group'></div> */}
        </div>
      </div>
    </>
  );
}

export default Upload;
